export const statesElement = {
    ENABLED: 1,
    DISABLED: 2
}

